import { makeAutoObservable } from 'mobx';
import { companyProfileStore } from './companyProfile.store';
import { ghgReportingStore } from './ghgReporting.store';
import { eidrStore } from './eidr.store';
import { benchmarkStore } from './benchmark.store';
import { sbtiStore } from './sbti.store';

class SummaryStore {
	isGeneralConfirmationModalOpen = false;

	constructor() {
		makeAutoObservable(this);
	}

	openGeneralConfirmationModal = () => (this.isGeneralConfirmationModalOpen = true);

	closeGeneralConfirmationModal = () => (this.isGeneralConfirmationModalOpen = false);

	handleSaveSummary = async () => {
		if (companyProfileStore.isCompanyProfileChanged) {
			await companyProfileStore.updateCompany();
		}

		if (ghgReportingStore.isGHGReportingChanged) {
			ghgReportingStore.updateGHGReporting();
		}

		if (eidrStore.isEIDRChanged) {
			await eidrStore.saveEIDR();
		}

		if (benchmarkStore.isIPBChanged) {
			await benchmarkStore.saveIPBData();
		}

		if (sbtiStore.isSBTiChanged) {
			await sbtiStore.saveSBTI();
		}

		this.isGeneralConfirmationModalOpen = false;
		return true;
	};
}

export const summaryStore = new SummaryStore();
